<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >
        <v-layout wrap>
          <v-flex
            xs12
            md12
            lg6
          >
            <material-card
              :color="color"
              :title="user.email"
            >
              <v-form>
                <v-container py-0>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="user.affiliate.firstname"
                        class="purple-input"
                        label="First name"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="user.affiliate.lastname"
                        class="purple-input"
                        label="Last name"
                      />
                    </v-flex>

                    <v-flex
                      xs12
                      md12
                    >
                      <v-text-field
                        v-model="user.affiliate.address"
                        class="purple-input"
                        label="Address"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md12>
                      <v-btn
                        style="float:right"
                        color="blue darken-1"
                        flat
                        @click="update">
                        Update
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
              <v-container>
                <div>
                  <h4>Payment Method</h4>

                  <p
                    v-if="!user.affiliate.has_payment"
                    style="color:lightcoral">You have to complete payment information before you can create transactions!</p>
                  <p
                    v-else
                    style="color:lightgreen">There's connected payment method for this client! <br> Note: Click below to update to a new payment method.</p>
                  <v-btn
                    v-if="!loadingPlaidLink"
                    color="blue darken-1"
                    flat
                    @click="loadLink">
                    {{ user.affiliate.has_payment?'ACH Connected, Click to update':'Add ACH Payment Method' }}
                  </v-btn>

                  <!--<PlaidLink :client_id="editedItem.id" :key="editedItem.id"> </PlaidLink>-->
                </div>
              </v-container>
            </material-card>
          </v-flex>
          <v-flex
            xs12
            md12
            lg6
          >
            <material-card
              :color="color"
              title="Change Password"
            >
              <v-form v-model="changePasswordValid">
                <v-container py-0>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        ref="changePassword.current_password"
                        v-model="changePassword.current_password"
                        :rules="[rules.required]"
                        type="password"
                        class="purple-input"
                        label="Current Password"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        ref="changePassword.password"
                        v-model="changePassword.password"
                        :rules="[rules.required, rules.min8chars]"
                        type="password"
                        label="New Password"
                        class="purple-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        ref="changePassword.password_confirmation"
                        v-model="changePassword.password_confirmation"
                        :rules="[rules.required, rules.min8chars, passwordConfirmationRule]"
                        type="password"
                        label="New Password Confirmation"
                        class="purple-input"
                      />
                    </v-flex>
                  </v-layout>
                  <v-btn
                    :color="color"
                    align-center
                    justify-center
                    @click="updatePassword">Change Password
                  </v-btn>
                  &nbsp;
                  <p style="color:red; display:inline">{{ changePasswordError }}</p>
                </v-container>
              </v-form>
            </material-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!--<v-flex-->
      <!--xs12-->
      <!--md4-->
      <!--&gt;-->
      <!--<material-card class="v-card-profile">-->
      <!--<v-avatar-->
      <!--slot="offset"-->
      <!--class="mx-auto d-block"-->
      <!--size="130"-->
      <!--&gt;-->
      <!--<img-->
      <!--src="/img/logo.png"-->
      <!--&gt;-->
      <!--</v-avatar>-->
      <!--<v-card-text class="text-xs-center">-->
      <!--<h6 class="category text-gray font-weight-thin mb-3">{{user.email}}</h6>-->
      <!--<h4 class="card-title font-weight-light">{{user.affiliate.firstname}} {{user.affiliate.lastname}}</h4>-->
      <!--&lt;!&ndash;<p class="card-description font-weight-light">At Blah Blah Blah, we design exquisite websites with unlimited features, functionalities, and SEO optimized. What will high Google ranking do for your company? Imagine your new website on the first page of search engines.</p>&ndash;&gt;-->
      <!--<p class="card-description font-weight-light">Address: {{user.affiliate.address}}</p>-->
      <!--</v-card-text>-->
      <!--</material-card>-->
      <!--</v-flex>-->
    </v-layout>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-btn
        flat
        @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'

  export default {
  data: function () {
    return {
      user: JSON.parse(localStorage.getItem('userInfo')),
      snack: false,
      snackColor: '',
      snackText: '',
      loadingPlaidLink: true,
      token_link: '',
      handler: null,
      changePassword: {
        password: '',
        password_confirmation: '',
        current_password: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        min8chars: v => v.length >= 8 || 'Minimum 8 characters!'
      },
      changePasswordError: ''
    }
  },
    computed: {
      ...mapState('app', ['color']),
      passwordConfirmationRule () {
        return () => (this.changePassword.password === this.changePasword.password_confirmation) || 'Password must match'
      }
    },
    created () {
      this.getTokenLink()
    },
    methods: {
      updatePassword () {
        if (!(this.changePasswordValid)) {
          this.snackText = 'Fill out current password and nwe password.'
          this.snackColor = 'error'
          this.snack = true
          return
        }
        this.changePasswordError = ''
        this.$store.state.spinning = true
        axios.put('/user/password/', this.changePassword)
                .then((response) => {
                          this.snackText = 'Password Updated successfully!'
                          this.snackColor = 'success'
                          this.snack = true
                          this.$store.state.spinning = false
                        }
                )
                .catch(error => {
                  if (error.response.status == '422') {
                    this.snackText = JSON.stringify(error.response.data.errors)
                    this.snackColor = 'error'
                    this.snack = true
                  } else {
                    this.snackText = 'Something went wrong, please try again later.'
                    this.snackColor = 'error'
                    this.snack = true
                  }
                  this.$store.state.spinning = false
                })
        console.log('updating password')
      },
      getTokenLink () {
        this.loadingPlaidLink = true
        axios.get('/api/token')
                .then(response => {
                  this.token_link = response.data.link_token
                  this.createHandler()
                  this.loadingPlaidLink = false
                })
                .catch(err => {
                  this.token_link = ''
                  this.loadingPlaidLink = false

                  console.log(err.message)

                  if (err.response.status == '403') {
                    this.showError('Unauthorized')
                  } else {
                    this.showError(err.response.data.errors)
                  }
                  console.log(err.response.data.errors)
                })
      },
      onSuccess (public_token, metadata) {
          axios.post('/api/token', { public_token: public_token, metadata: metadata })
            .then(response => {
              this.user = response.data
              localStorage.setItem('user', JSON.stringify(this.user))
              localStorage.setItem('userInfo', JSON.stringify(this.user))
              this.snack = true
              this.snackColor = 'success'
              this.snackText = 'Payment information created!'
            })
            .catch(err => {
              if (err.response.status == '403') {
                this.showError('Unauthorized')
              } else {
                this.showError(err.response.data.errors)
              }
              console.log(err.response.data.errors)
            })
      },
      createHandler () {
        this.handler = Plaid.create({
          // Create a new link_token to initialize Link
          token: this.token_link,
          onLoad: function () {
            // Optional, called when Link loads
          },
          onSuccess: this.onSuccess
          // onExit: function(err, metadata) {
          //     // The user exited the Link flow.
          //     if (err != null) {
          //         // The user encountered a Plaid API error prior to exiting.
          //     }
          //     // metadata contains information about the institution
          //     // that the user selected and the most recent API request IDs.
          //     // Storing this information can be helpful for support.
          // },
          // onEvent: function(eventName, metadata) {
          //     // Optionally capture Link flow events, streamed through
          //     // this callback as your users connect an Item to Plaid.
          //     // For example:
          //     // eventName = "TRANSITION_VIEW"
          //     // metadata  = {
          //     //   link_session_id: "123-abc",
          //     //   mfa_type:        "questions",
          //     //   timestamp:       "2017-09-14T14:42:19.350Z",
          //     //   view_name:       "MFA",
          //     // }
          // }
        })
      },
      loadLink () {
        this.handler.open()
      },
      update () {
        let self = this
        if (this.user.affiliate && this.user.affiliate.id && this.user.affiliate.id > -1) {
          this.$store.state.spinning = true
          axios.put('/api', this.user.affiliate)
                  .then(response => {
                    self.user = response.data
                    localStorage.setItem('user', JSON.stringify(self.user))
                    localStorage.setItem('userInfo', JSON.stringify(self.user))
                    this.saveSuccessful()
                    this.$store.state.spinning = false
                  })
                  .catch(err => {
                    if (err.response.status == '403') {
                      this.showError('Unauthorized')
                    } else {
                      this.showError(err.response.data.errors)
                    }
                    console.log(err.response.data.error)
                    this.$store.state.spinning = false
                  })
        }
      },
      saveSuccessful () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Profile updated'
      },
      showError (errorMessage) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = errorMessage || 'Something went wrong, try again later!'
      }
    }
}
</script>
